import type { ListInfo } from '@synqo/frontend-component-library';

export interface ExternalErpItem {
    id: string;
    external_id: string;
}

/**
 * The page with each item's external id as its id: items from an external ERP have no id of ours yet,
 * but a table keys its rows by id, and the external id is unique.
 */
// @ai-generated 2026-10-23T08:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const withExternalIdsAsIds = <TItem extends ExternalErpItem>(page: ListInfo<TItem>): ListInfo<TItem> => ({
    ...page,
    items: page.items.map((item) => ({ ...item, id: item.external_id })),
});
